import { baseUrl } from "utils/api";

const token = localStorage.getItem("token");

const fetchData = async (url) => {
  const res = await fetch(url, {
    headers: {
      "Content-Type": "application/json",
      Authorization: `Bearer ${token}`,
    },
  });
  return res.json();
};

// fetch stock items
const fetchStockItems = async () => {
  return await fetchData(`${baseUrl}stocks`);
};

// fetch suppliers
const fetchSuppliers = async () => {
  return await fetchData(`${baseUrl}supplier`);
};

// fetch stock categories
const fetchStockCategories = async () => {
  return await fetchData(`${baseUrl}category`);
};

// fetch single stock category
const fetchStockCategory = async (id) => {
  return await fetchData(`${baseUrl}category/${id}`);
};

// fetch stock class
const fetchStockClasses = async () => {
  return await fetchData(`${baseUrl}stockzclass`);
};

// fetch stock class
const fetchStores = async () => {
  return await fetchData(`${baseUrl}storez`);
};

// fetch stock class
const fetchStoreLocations = async () => {
  return await fetchData(`${baseUrl}storelocation`);
};

// fetch stock levies
const fetchLevies = async () => {
  return await fetchData(`${baseUrl}levies`);
};

// fetch stock units
const fetchUnits = async () => {
  return await fetchData(`${baseUrl}unitz`);
};

// fetch stock units
const fetchCustomers = async () => {
  return await fetchData(`${baseUrl}customer`);
};

// fetch stock users
const fetchUsers = async () => {
  return await fetchData(`${baseUrl}oath`);
};

// fetch cost centers
const fetchCostCenters = async () => {
  return await fetchData(`${baseUrl}costcenter`);
};

// fetch currencies

const fetchCurrencies = async () => {
  return await fetchData(`${baseUrl}currencies`);
};

// FETCH TRANSACTION DETAILS
// fetch next transaction no.

const fetchTransactionTypes = async () => {
  return await fetchData(`${baseUrl}trantype`);
};

const fetchNextTransactionNo = async () => {
  return await fetchData(`${baseUrl}trantype/getNextTransactionNo/CSL`);
};

export {
  fetchData,
  fetchStockItems,
  fetchSuppliers,
  fetchStockCategories,
  fetchStockCategory,
  fetchStockClasses,
  fetchStoreLocations,
  fetchStores,
  fetchLevies,
  fetchUnits,
  fetchCustomers,
  fetchUsers,
  fetchCostCenters,
  fetchCurrencies,
  fetchTransactionTypes,
  fetchNextTransactionNo,
};
